
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strains/[strainSlug]/photos",
      function () {
        return require("private-next-pages/strains/[strainSlug]/photos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strains/[strainSlug]/photos"])
      });
    }
  